import { render, staticRenderFns } from "./listing-box-new.vue?vue&type=template&id=0f385a7e&"
import script from "./listing-box-new.vue?vue&type=script&lang=js&"
export * from "./listing-box-new.vue?vue&type=script&lang=js&"
import style0 from "./listing-box-new.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports